export default __webpack_public_path__ + "static/media/sortAscending_down.06550111.svg";